{
  "propertyCompanyGroup": {
    "name": "Pandia"
  },
  "bulletin": "Tiedotteet",
  "moreBulletins": "Lisää tiedotteita",
  "noBulletins": "Ei uusia tiedotteita",
  "test": "testi",
  "hi": "Hei",
  "email": "Sähköposti",
  "emailForContact": "Sähköposti yhteydenottoon",
  "residentId": "Asukassivutunnus",
  "phone": "Puhelin",
  "comingSoon": "Tulossa",
  "edit": "Muokkaa",
  "cancel": "Peruuta",
  "closeButton": "Sulje",
  "save": "Tallenna",
  "preview": "Esikatsele",
  "next": "Seuraava",
  "file": "Tiedosto",
  "thankYou": "Kiitos",
  "formSent": "{{form}} on lähetetty.",
  "editFormSent": "{{form}} on tallennettu.",
  "backToHome": "Takaisin etusivulle",
  "back": "Takaisin",
  "impersonatorWriteOnlyModeError": "Asiakkaan puolesta kirjautuneena käyttäjänä ei ole oikeutta muuttaa tietoja.",
  "movedOutReadOnlyModeError": "Olet muuttanut pois, joten voit enää katsella tietoja sekä lähettää viestejä, kysymyksiä ja palautetta.",
  "notKnown": "Ei tiedossa",
  "yes": "Kyllä",
  "no": "Ei",
  "additionalNotification": "Kiireellisissä asioissa ota yhteys asiakaspalveluun.",
  "logOut": "Kirjaudu ulos",
  "showMore": "Näytä lisää",
  "waysToCommunicate": "Viestintätoiveet",
  "communicationByEmail": "Sähköposti",
  "communicationBySms": "Tekstiviesti",
  "marketingAllowed": "Markkinointilupa",
  "paperInvoice": "Paperilasku",
  "eInvoice": "E-lasku",
  "inUse": "Käytössä",
  "notInUse": "Ei käytössä",
  "views": {
    "home": "Etusivu",
    "userInfo": "Omat tiedot",
    "payments": "Laskut ja maksutiedot",
    "defectNotice": "Tee vikailmoitus",
    "documents": "Dokumentit",
    "bulletin": "Tiedote",
    "building": "Kiinteistön tiedot",
    "bulletinBoard": "Kaikki tiedotteet",
    "contactInfo": "Yhteystiedot"
  },
  "taskLinks": {
    "defectNotice": "Vikailmoitus",
    "payments": "Maksutiedot",
    "saunaReservation": "Saunavuoro",
    "commonAreaReservations": "Kokoontumistilat",
    "moveNotice": "Irtisanominen",
    "residentChanges": "Asukasmuutokset"
  },
  "navbar": {
    "profile": "Avaa profiili",
    "home": "Etusivu",
    "transactions": "Asiointi",
    "faultReport": "Vikailmoitus",
    "terminateContract": "Irtisano sopimus",
    "residentChanges": "Asukasmuutokset",
    "messages": "Viestit",
    "feedback": "Palaute",
    "questions": "Kysymykset",
    "userInfo": "Omat tiedot",
    "payments": "Maksutiedot",
    "ownProperty": "Oma koti",
    "documents": "Dokumentit",
    "building": "Kiinteistön tiedot",
    "openMenu": "Avaa valikko",
    "openProfile": "Avaa profiili",
    "bulletinBoard": "Kaikki tiedotteet",
    "contactInfo": "Yhteystiedot",
    "parkingSpots": "Pysäköintipaikat",
    "saunaReservations": "Saunavuorot",
    "laundryReservations": "Pesulavaraukset",
    "gymBooking": "Kuntosalivuorot",
    "gymReservations": "Kuntosalivaraukset",
    "commonAreaReservations": "Kokoontumistilat",
    "storages": "Varastot"
  },
  "placeholders": {
    "date": "pp.kk.vvvv",
    "select": "Valitse"
  },
  "datePicker": {
    "monthEndOnly": "Sopimuksen päättymispäivä on aina kuukauden viimeinen päivä",
    "monthEndOnlyValidation": "Valitse kuukauden viimeinen päivä"
  },
  "today": "Tänään",
  "week": "Viikko",
  "month": "Kuukausi",
  "copy": "Kopioi",
  "userInfo": {
    "securitySectionHeader": "Tietoturva",
    "changePassword": "Vaihda salasana",
    "strongAuth": {
      "sectionHeader": "Tunnistautuminen",
      "infoText": "Sopimusmuutosten tekeminen vaatii tunnistautumisen. Voit tunnistautua alla olevasta painikkeesta.",
      "authButton": "Tunnistaudu"
    },
    "description1": "Käytämme näitä yhteystietoja muun muassa asuntotarjouksiin, vikailmoituksiin, sopimusmuutoksiin ja muihin tiedotusasioihin liittyen.",
    "description2": "Asukassivutunnuksena käyttämäsi sähköposti on mahdollista vaihtaa vain rekisteröitymällä uudelleen.",
    "communicationPreferencesInfo": "Valitse, miten toivot ensisijaisesti vastaanottavasi viestejä. Valinta ei vaikuta siihen, mitä kautta välttämättömät viestit voidaan toimittaa.",
    "permissionsHeader": "Luvat",
    "marketingAllowedDescription": "Haluan kuulla eduista ja kampanjoista",
    "electronicServicesConsent": "Sähköisen asioinnin lupa",
    "electronicServicesConsentDescription": "Minulle voi lähettää viralliset asiakirjat sähköisesti",
    "removeUser": {
      "buttonText": "Poista tunnus",
      "confirmationText": "Haluatko varmasti poistaa tunnuksen?"
    }
  },
  "complete": "Valmis",
  "tryAgain": "Yritä uudelleen",
  "reloadPage": "Lataa sivu uudelleen",
  "newVersionAvailable": "Asukassivuista on saatavilla uusi versio. Lataa sivu uudelleen.",
  "newVersionTitle": "Asukassivut on päivitetty!",
  "closeWindow": "Sulje ikkuna päivittämättä",
  "alt": {
    "illustration": "kuvitus"
  },
  "uploadFilesInputText": "Klikkaa tästä tai raahaa tiedosto. Maksimikoko on 10 Mt.",
  "uploadFilesInputError": "Liittämäsi tiedosto on liian iso tai väärää tyyppiä. Sallitut tiedostotyypit ovat",
  "cookieConsent": {
    "readMoreLinkText": "Lisätietoja Pandian evästekäytännöistä täältä",
    "readMoreLink": "https://pandia.fi/"
  },
  "buildingInfo": {
    "title": "Perustiedot",
    "district": "Kaupunginosa",
    "constructionDate": "Valmistumisvuosi",
    "realPropertyAreasTotal": "Asuntoja",
    "heatingMethod": "Lämmitysmuoto",
    "internetOperator": "Nettioperaattori",
    "internetProvider": "Internetpalveluntarjoaja",
    "connectionSpeed": "Yhteyden nopeus",
    "realPropertyPictureAlt": "Kuva kiinteistöstä",
    "contactInformation": "Yhteystiedot",
    "noContactInformation": "Yhteystietoja ei löydy",
    "sales": "Myynti",
    "residentsCommittee": "Asukastoimikunta",
    "giveFeedback": "Anna palautetta",
    "askQuestion": "Kysy asumisesta",
    "heatingMethods": {
      "airToWaterHeatPump": "Ilmavesilämpöpumppu",
      "districtAndExhaustAirHeatPump": "Kaukolämpö ja poistoilmalämpöpumppu",
      "districtAndSolar": "Kaukolämpö ja aurinkolämpö",
      "districtHeating": "Kaukolämpö",
      "electricHeating": "Sähkölämmitys",
      "gas": "Kaasu",
      "geothermalAndSolar": "Maalämpö ja aurinkolämpö",
      "geothermalHeating": "Maalämpö",
      "naturalGasHeating": "Maakaasulämmitys",
      "noHeating": "Ei lämmitystä",
      "notSet": "Ei tiedossa",
      "oilHeating": "Öljylämmitys",
      "solar": "Aurinkoenergia"
    }
  },
  "charactersRemaining": "Merkkejä jäljellä: {{count}}",
  "sensitiveDataWarning": "Huom! Huomioithan, että viestiin ei tule sisällyttää arkaluontoisia henkilötietoja, kuten henkilötunnusta, salasanoja tai muita luottamuksellisia tietoja.",
  "dateTime": {
    "weekAbbreviation": "VKO",
    "today": "Tänään",
    "months": {
      "in": {
        "10": "lokakuussa",
        "11": "marraskuussa",
        "12": "joulukuussa",
        "01": "tammikuussa",
        "02": "helmikuussa",
        "03": "maaliskuussa",
        "04": "huhtikuussa",
        "05": "toukokuussa",
        "06": "kesäkuussa",
        "07": "heinäkuussa",
        "08": "elokuussa",
        "09": "syyskuussa"
      }
    }
  },
  "residentDetailsTitle": "Lisätiedot"
}